export class ProduktDetailTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static uppfoljning0100 = "Du måste ange ett värde mellan 0 och 100. Inga decimaler tillåtna.";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        tabBasdata: "Basdata och kundspecifika krav",
        tabFordelningsmatris: "Fördelningsmatris",
        tabUppfoljning: "Uppföljning",
        tabProduktinstruktioner: "Produktinstruktioner",
        pageTitleNewProdukt: "Skapa ny produkt",
        pageTitleProdukt: "Produkt",
        visaLogg: "Visa logg",
        deletePromtTitle: "Radera produkt",
        deletePromptText: "Bekräfta radering av produkt",
        deleteProduktConfirmed: "Produkten har tagits bort",
        saveProduktConfirmed: "Ändringarna sparades",
        produktspecifikation: "Produktspecifikation",
        giltigFrom: "Giltig fr.o.m.",
        giltigTom: "Giltig t.o.m.",
        copy: {
            title: "Kopiera",
            produktWithSpec: "Produkt med vald Produktspecifikation",
            produktWithoutSpec: "Produkt utan Produktspecifikation",
            specifikation: "Vald Produktspecifikation"
        }
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static validation = {
        giltigFrom: "Du måste ange ett giltigt datum som är mindre eller lika som t.o.m. datum",
        giltigTom: "Du måste ange ett giltigt datum som är större eller lika som fr.o.m. datum"
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static productDetailHeader = {
        texts: {
            namn: "Namn",
            beteckning: "Beteckning",
            produktgrupp: "Produktgrupp",
            tradslag: "Trädslag",
            sortiment: "Sortimentskod",
            beskrivning: "Beskrivning",
            aktiv: "Aktiv",
            skapadAv: "Skapad av",
            traddel: "Träddel",
            inaktiv: "(inaktiv)",
            traddelar: {
                rot: "Rot",
                mellanTopp: "Mellan/topp",
                allaStock: "Alla - stock"
            }
        },
        validation: {
            namnRequired: "Du måste ange ett produktnamn",
            produktgruppRequired: "Du måste ange en produktgrupp",
            sortimentRequired: "Du måste ange minst en sortimentskod",
            maxLength: "För många tecken har angivits"
        }
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static basTab = {
        texts: {
            btnLaggTill: "Lägg till ny mätningsinstruktion",
            btnLaggTillLangdModul: "Lägg till längdmodul",
            btnSkapaFordelningsmatris: "Skapa fördelningsmatris",
            btnSkapaLangdmoduler: "Skapa längdmoduler",
            checkboxManuelltKap: "Manuellt kap",
            inputLankHeader: "Text som ska visas",
            inputLankTillMatningsinstruktion: "Länk till",
            inputToppDiaMinMax: "Toppdiameter min - max",
            inputRotDiaMax: "Rotdiameter max",
            inputLangdMinMax: "Längd min - max",
            inputLangdintervall: "Längdintervall",
            inputLangmoduler: "Längdmoduler",
            inputOvermalMinMax: "Övermål för längder min - max",
            inputFukthalt: "Fukthalt",
            inputFlisstorlek: "Önskad flisstorlek",
            infoManuelltKap: "Ej önskad längd - Blå markering",
            infoLangdintervall: "Ange vilket intervall som ska användas för att generera upp ett antal längdmoduler utifrån min-max-längdgränser",
            infoOvermal: "Ange hur många centimeter längre kunden vill ha alla stockar för att vara säker på att den inte blir för kort för modulgränsen",
            headerBasdata: "Basdata",
            headerKundspecifikaKrav: "Kundspecifika krav",
            headerMatningsinstruktion: "Mätningsinstruktion",
            tagLangder: "Längder",
            tagClearAll: "Ta bort alla längder",
            textareaInfoTillMaskinlag: "Särskild information till maskinlag",
            thLank: "Länk",
            thLadesTill: "Lades till",
            thTaBort: "Ta bort",
            infoMatningsinstruktionlank: "Du kan länka till en mätningsintruktion på virkesmätningsföreningens webbplats eller lägga upp på sharepoint och länka dit."
        },
        validation: {
            diaTopMin: "Måste vara ett värde mellan 0.1 och 1000 och mindre än maxvärdet. Endast en decimal tillåten.",
            diaTopMax: "Måste vara ett värde mellan 0.1 och 1000 och större än minvärdet. Endast en decimal tillåten.",
            diaRotMax: "Måste vara ett värde mellan 0.1 och 1000. Endast en decimal är tillåten.",
            langdgransMin: "Måste vara ett värde mellan 1 och 5000 och mindre än maxvärdet. Inga decimaler tillåtna.",
            langdgransMax: "Måste vara ett värde mellan 1 och 5000 och större än minvärdet. Inga decimaler tillåtna.",
            overmalMin: "Måste vara mellan 0.1 och 50 och mindre än maxvärdet. Endast en decimal tillåten",
            overmalMax: "Måste vara mellan 0.1 och 50 och större än minvärdet. Endast en decimal tillåten",
            sarskildInfo: "Får inte överskrida 2000 tecken.",
            matningsinstruktionslank: "Måste vara en URL: t.ex. https://sveaskog.se",
            nyLangdmodul: "Måste vara större än längd minvärde och mindre än längd maxvärde samt får inte redan finnas.",
            fukthalt: "Måste vara mellan 0 och 100. Inga decimaler tillåtna.",
            flisstorlekOnskad: "Måste vara mellan 0.1 och 30. Endast en decimal tillåten."
        }
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static uppfoljningTab = {
        texts: {
            modultraff: "Modulträff (cm) min - max",
            varningLarmniva: "Varnings- och larmnivåer",
            rotandelMax: "Maximal rötandel (%)",
            meddellangdOptimerad: "Optimerad medellängd (cm)",
            varning: "Varning %",
            larm: "Larm %",
            langdfordelning: "Längdfördelning",
            diameterfordelning: "Diameterfördelning",
            fordelningsgrad: "Fördelningsgrad",
            vrakandel: "Vrakandel",
            manuellaKap: "Manuella kap",
            flisstorlekandel: "Flisstorlekandel",
            fukthaltandel: "Fukthaltandel",
            langdfordelningForklaring: "Varning/Larm inträffar om Längdfördelning UNDERSTIGER angivet värde",
            diameterfordelningForklaring: "Varning/Larm inträffar om Diameterfördelning UNDERSTIGER angivet värde",
            fordelningsgradForklaring: "Varning/Larm inträffar om Fördelningsgrad UNDERSTIGER angivet värde",
            vrakandelForklaring: "Varning/Larm inträffar om Vrakandel ÖVERSTIGER angivet värde",
            manuellaKapForklaring: "Varning/Larm inträffar om Manuella kap ÖVERSTIGER angivet värde",
            flisstorlekandelForklaring: "Varning/Larm inträffar om Flisstorlekandel UNDERSTIGER angivet värde",
            fukthaltandelForklaring: "Varning/Larm inträffar om Fukthaltandel ÖVERSTIGER angivet värde"
        },
        validation: {
            modultraffMin: "Du måste ange ett värde mellan -50,0 och 50,0 som är mindre än Max-värdet",
            modultraffMax: "Du måste ange ett värde mellan -50,0 och 50,0 som är större än Min-värdet",
            rotandelMax: ProduktDetailTexts.uppfoljning0100,
            meddellangdOptimerad: "Du måste ange ett värde mellan 0,1 och 5 000. Endast en decimal är tillåten.",
            varningsniva: ProduktDetailTexts.uppfoljning0100,
            larmniva: ProduktDetailTexts.uppfoljning0100
        }
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static fordelningsmatrisTab = {
        texts: {
            btnGenereraLangdmoduler: "Generera från längdmoduler",
            btnRensa: "Rensa",
            btnForbjuden: "Förbjuden",
            btnMin: "Min",
            btnMax: "Max",
            fordelningsmatris: "Fördelningsmatris",
            hotHeader: "Längd / Diameter",
            editLangd: "Ändra/ta bort längd",
            laggTillLangd: "Lägg till ny längd",
            editDiameter: "Ändra/ta bort diameter",
            laggTillDiameter: "Lägg till ny diameter",
            diameterfordelningMinMax: "Ange ett värde mellan {0} och {1} med en decimals noggrannhet som inte redan finns.",
            langdmodulMinMax: "Ange ett värde mellan {0} och {1} som inte redan finns.",
            diameter: "Diameter *",
            langd: "Längd *",
            andra: "Ändra",
            laggTill: "Lägg till",
            teckenforklaringDiameter: "Diameter i cm. Min: {0}. Max: {1}",
            teckenforklaringLangd: "Längder i cm. Min: {0}. Max: {1}",
            genereraFranLangdmodulerHelpText: `För att generera från längdmoduler krävs att ett min och max värde finns för längd, ` +
                `samt ett min värde för diameter och att längdmoduler finns.`,
            showFordelningsmatrisHelpText: "För att se fördelningsmatrisen krävs att längd min och max och diameter min är satta.",
            taBort: "Ta bort",
            avbryt: "Avbryt"
        },
        validation: {
            langdmodulModalLangd: "Värdet måste vara inom min-max och det får inte redan finnas registrerat. Inga decimaler tillåtna.",
            diameterfordelningModalDiameter: "Värdet måste vara inom min-max och det får inte redan finnas registrerat. Endast en decimal tillåten."
        }
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static produktinstruktionerTab = {
        texts: {
            produktinstruktioner: "Produktinstruktioner",
            sortiment: "Sortiment",
            hssortiment: "Handelssortiment",
            namn: "Namn",
            puid: "PUID",
            mottplats: "Mottagningsplats",
            mottplatsViol3: "Mottagningsplats Viol3",
            version: "Version",
            laddaNedPin: "Ladda ned PIN-fil",
            laddaNedPinv3: "Ladda ned V3 PIN-fil",
            sokProduktinstruktion: "Sök produktinstruktion",
            sok: "Sök",
            rensa: "Rensa",
            laggTill: "Lägg till"
        },
        validation: {
        }
    };
}
